import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/browser";
import Dialog, { DialogContent } from "./Dialog";
import { Button } from "../inputs/Button";
import styled from "styled-components";
import { Text } from "@fluentui/react-components";

const messageContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "10px",
  alignSelf: "stretch",
  maxHeight: "calc(100vh - 170px)",
  width: "100%",
  overflowY: "auto"
};

export default class ErrorDialog extends Component {
  state = { eventId: null };

  componentDidMount() {
    if (this.props.error) {
      const eventId = Sentry.captureException(this.props.error);
      this.setState({ eventId });
    }
  }

  onShowReportDialog = () => {
    Sentry.showReportDialog({
      eventId: this.state.eventId,
      user: {
        name: "Anonymous Spoke User",
        email: "anonymous.spoke.user@mozilla.com"
      }
    });
  };

  renderBottomNav() {
    return this.state.eventId ? (
      <Button onClick={this.onShowReportDialog}>Submit Feedback</Button>
    ) : null;
  }

  render() {
    const { message, errorDetails } = this.props;

    const errorDetailsElements = errorDetails
      ? errorDetails
          .split(".")
          .filter(sentence => sentence.trim() !== "")
          .map((sentence, index) => (
            <React.Fragment key={index}>
              {sentence}.
              <br />
            </React.Fragment>
          ))
      : null;

    return (
      <Dialog
        title={this.props.title}
        confirmHref={this.props.confirmHref}
        onConfirm={this.props.onConfirm}
        confirmLabel={this.props.confirmLabel}
        onCancel={this.props.onCancel}
        cancelLabel={this.props.cancelLabel}
      >
        <div style={{ ...messageContainer }}>
          <Text style={{ overflowWrap: "break-word", maxWidth: "100%" }}>
            {message}
            {errorDetailsElements && (
              <>
                <br />
                {errorDetailsElements}
              </>
            )}
          </Text>
        </div>
      </Dialog>
    );
  }
}

ErrorDialog.propTypes = {
  title: PropTypes.string.isRequired,
  error: PropTypes.object,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  confirmLabel: PropTypes.string,
  extraSpace: PropTypes.number,
  errorDetails: PropTypes.string,
  confirmHref: PropTypes.string
};

ErrorDialog.defaultProps = {
  title: "Error"
};
